/** UI texts of the intelligence upgrade (score, evidence, timeframes, news). Each key must exist in both languages. */
export const intelUi = {
  en: {
    "set.data.calendarNone": "None",
    "set.data.calendarProviderHint": "Scheduled releases (CPI, NFP, FOMC …) for the News tab and for the news lock of the checks (Settings → Checks).",
    "set.data.calendarProvider": "Economic calendar",
    "tf.15m": "15 min",
    "tf.5m": "5 min",

    "field.data.newsRefreshMinutes.label": "News refresh interval",
    "set.data.newsProvider": "News source",

    "set.data.newsProviderHint": "Source of the headlines and events (News tab).",
    "set.data.newsNone": "None (no news)",
  } as Record<string, string>,
  de: {
    "set.data.calendarNone": "Keiner",
    "set.data.calendarProviderHint": "Geplante Termine (CPI, NFP, FOMC …) für den Reiter News und für die News-Sperre der Prüfungen (Einstellungen → Prüfungen).",
    "set.data.calendarProvider": "Wirtschaftskalender",
    "tf.15m": "15 Min.",
    "tf.5m": "5 Min.",

    "field.data.newsRefreshMinutes.label": "Aktualisierung der Nachrichten",
    "set.data.newsProvider": "Nachrichtenquelle",

    "set.data.newsProviderHint": "Anbieter für Schlagzeilen und Ereignisse (Reiter News).",
    "set.data.newsNone": "Keine (ohne Nachrichten)",
  } as Record<string, string>,
};
